import { Box, Button, Dialog, DialogContent, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery, Select, MenuItem, DialogTitle, DialogContentText, DialogActions } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Header from '../../../components/Header';
import { useTheme } from '@emotion/react';
import { tokens } from '../../../theme';
import EditIcon from '@mui/icons-material/Edit';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAllDealersData, getDealerPayment } from '../../../redux/slice/dealerPayment.slice';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

const Dealerpayment = () => {

    const dispatch = useDispatch()
    const location = useLocation();
    const isMobile = useMediaQuery('(max-width:500px)');
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const DealerRegister = useSelector(state => state.dealerPayment.dealersData)

    useEffect(() => {
        dispatch(getDealerPayment())
        dispatch(getAllDealersData())
    }, [])

    const [selectedDealers, setSelectedDealers] = useState([]);

    useEffect(() => {
        const dataToSubmit = DealerRegister?.filter(v => v.requestStatus === "Approved");
        setSelectedDealers(dataToSubmit);
    }, [DealerRegister])

    const navigate = useNavigate();
    const handleEdit = (v, billNo, dealer, deaperPayementId, userId) => {
        console.log("v, billNo, dealer, deaperPayementId, userId", v, billNo, dealer, deaperPayementId, userId);

        navigate('/admin/dealer-payment-show', { state: { v, billNo, dealer, deaperPayementId, userId } });
    }

    const Dealerpayment = useSelector(state => state.dealerPayment.DealerPayment);

    console.log("Dealerpayment", Dealerpayment);


    const [selectedYear, setSelectedYear] = useState('Select Year');
    const [selectedMonth, setSelectedMonth] = useState('Select Month');

    const handleYearChange = (event) => {
        setSelectedYear(event.target.value);
    };

    const handleMonthChange = (event) => {
        setSelectedMonth(event.target.value);
    };

    const aggregatedDealers = useMemo(() => {
        const grouped = {};
        const currentDate = new Date();
        let isFirstEntry = true;

        selectedDealers?.forEach(dealer => {
            const commissionDate = new Date(dealer.commisionCreatedAt);
            if (commissionDate <= currentDate) {
                const year = commissionDate.getFullYear();
                const month = commissionDate.getMonth();
                const day = commissionDate.getDate();
                const periodKey = `${year}-${month}`;
                const dealerName = dealer.dealerUserData[0]?._id;
                const dealerdata = dealer.data[0];
                const AccountData = dealer.accountData[0].AccountDetails.reduce((acc, account) => acc + Number(account.AccountAmount), 0);

                if ((selectedYear === 'Select Year' || selectedYear == year) &&
                    (selectedMonth === 'Select Month' || selectedMonth === new Date(0, month).toLocaleString('default', { month: 'long' }))) {

                    if (dealer.submitDate) {
                        const submitKey = `${periodKey}-submited-${new Date(dealer.submitDate).toLocaleDateString('en-GB')}`;
                        if (!grouped[submitKey]) {
                            const startDate = isFirstEntry ? new Date(year, month, 1) : new Date(year, month, day);
                            const endDate = new Date(year, month + 1, 0);
                            grouped[submitKey] = {
                                startDate,
                                endDate,
                                formattedStartDate: startDate.toLocaleDateString('en-GB'),
                                formattedEndDate: endDate.toLocaleDateString('en-GB'),
                                dealers: [],
                                submitDate: dealer.submitDate,
                            };
                            isFirstEntry = false;
                        }
                        grouped[submitKey].dealers.push({
                            name: dealerName,
                            fileNo: dealerdata?.fillNo,
                            Consumername: dealerdata?.ConsumerName,
                            SystemSize: dealerdata?.SystemSizeKw,
                            CommissionKw: dealerdata?.CommissionPerKW,
                            dealerCommission: dealerdata?.TotalCommission,
                            TotalAmount: dealerdata?.TotalAmount,
                            AccountTotal: AccountData,
                            commission: Number(dealer.dealerCommission),
                        });
                    } else {
                        if (!grouped[periodKey]) {
                            const startDate = isFirstEntry ? new Date(year, month, 1) : new Date(year, month, day);
                            const endDate = new Date(year, month + 1, 0);
                            grouped[periodKey] = {
                                startDate,
                                endDate,
                                formattedStartDate: startDate.toLocaleDateString('en-GB'),
                                formattedEndDate: endDate.toLocaleDateString('en-GB'),
                                dealers: [],
                            };
                            isFirstEntry = false;
                        }
                        grouped[periodKey].dealers.push({
                            name: dealerName,
                            fileNo: dealerdata?.fillNo,
                            Consumername: dealerdata?.ConsumerName,
                            SystemSize: dealerdata?.SystemSizeKw,
                            CommissionKw: dealerdata?.CommissionPerKW,
                            dealerCommission: dealerdata?.TotalCommission,
                            TotalAmount: dealerdata?.TotalAmount,
                            AccountTotal: AccountData,
                            commission: Number(dealer.dealerCommission),
                        });
                    }
                }
            }
        });

        return Object.entries(grouped).map(([key, value]) => ({
            periodKey: key,
            ...value,
            dealers: value.dealers.reduce((acc, dealer) => {
                const existingDealer = acc.find(d => d.name === dealer.name);
                if (existingDealer) {
                    existingDealer.commission += dealer.commission;
                    existingDealer.details.push(dealer);
                } else {
                    acc.push({
                        name: dealer.name,
                        commission: dealer.commission,
                        details: [dealer],
                    });
                }
                return acc;
            }, []),
        }));
    }, [selectedDealers, selectedYear, selectedMonth]);

    const groupDealersByCommissionPeriod = (data) => {
        console.log(data);

        const arr = Array.isArray(data) ? data : [];
        return arr.reduce((acc, item) => {
            const key = item.billNo ? item.billNo : 'no-bill';
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(item);
            return acc;
        }, {});
    };

    const groupedDealers = groupDealersByCommissionPeriod(selectedDealers);

    // const sortedFab = Object.entries(groupedDealers)
    //     .map(([key, records]) => ({
    //         key,
    //         data: records
    //     }))
    //     .sort((a, b) => {
    //         if (a.key === "no-bill") return -1;
    //         if (b.key === "no-bill") return 1;

    //         const latestA = new Date(a.data[0].commisionCreatedAt);
    //         const latestB = new Date(b.data[0].commisionCreatedAt);
    //         return latestB - latestA; // descending
    //     });

    const sortedFab = Object.entries(groupedDealers)
        .map(([key, records]) => ({
            key,
            data: records
        }))
        .sort((a, b) => {
            if (a.key === "no-bill") return -1;
            if (b.key === "no-bill") return 1;

            // find max billNo in each group
            const maxBillA = Math.max(...a.data.map(r => parseInt(r.billNo, 10) || 0));
            const maxBillB = Math.max(...b.data.map(r => parseInt(r.billNo, 10) || 0));

            return maxBillB - maxBillA; // descending
        });


    console.log("sortedFab", sortedFab);



    const [openView, setOpenView] = React.useState(false);
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [viewData, setViewData] = useState(null);


    const handleClickOpenView = () => {
        setOpenView(true);
    };

    const handleCloseView = () => {
        setOpenView(false);
    };

    const handleview = (data) => {
        console.log("handleview", data);

        handleClickOpenView();
        setViewData(data);
    }

    return (
        <Box m="2px" sx={{ overflow: isMobile ? 'auto' : 'hidden', }}>
            <Header
                title="DEALER PAYMENT"
                subtitle="Manage Your Dealer Payment Here"
            />
            <Select
                value={selectedMonth}
                onChange={handleMonthChange}
                displayEmpty
                sx={{
                    minWidth: '100%',
                    [theme.breakpoints.up('sm')]: {
                        minWidth: '200px',
                    },
                    [theme.breakpoints.down('sm')]: {
                        minWidth: '100%',
                    },
                    marginBottom: '20px', marginRight: '20px',
                    '& .MuiSelect-select': {
                        padding: '8px',
                        border: 'none',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#566585',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#566585',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#566585',
                        borderWidth: '2px',
                    },
                }}
            >
                <MenuItem value="Select Month">Select Month</MenuItem>
                {['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].map((month, index) => (
                    <MenuItem key={index} value={month}>{month}</MenuItem>
                ))}
            </Select>

            <Select
                value={selectedYear}
                onChange={handleYearChange}
                displayEmpty
                sx={{
                    minWidth: '100%',
                    [theme.breakpoints.up('sm')]: {
                        minWidth: '200px',
                    },
                    [theme.breakpoints.down('sm')]: {
                        minWidth: '100%',
                    },
                    marginBottom: '20px',
                    '& .MuiSelect-select': {
                        padding: '8px',
                        border: 'none',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#566585',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#566585',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#566585',
                        borderWidth: '2px',
                    },
                }}
            >
                <MenuItem value="Select Year">Select Year</MenuItem>
                {Array.from({ length: 31 }, (_, index) => 2020 + index).map(year => (
                    <MenuItem key={year} value={year}>{year}</MenuItem>
                ))}
            </Select>





            {sortedFab.length > 0 ? (
                <TableContainer>
                    <Table>
                        <TableHead sx={{ backgroundColor: theme.palette.mode === 'dark' ? '#3e4396' : '#a4a9fc' }}>
                            <TableRow>
                                <TableCell style={{ width: '100px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>SR No.</TableCell>
                                <TableCell style={{ width: '330px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Invoice No</TableCell>
                                <TableCell style={{ width: '250px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Date of Period</TableCell>
                                <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Dealer Name</TableCell>
                                <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Total Amount</TableCell>
                                <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Given Payment</TableCell>
                                <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Payment Date</TableCell>
                                <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Status</TableCell>
                                {/* <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Payment History</TableCell> */}
                                <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Action</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {sortedFab.map(({ key, data }, index) => {
                                console.log("key, data", key, data);

                                const result = {
                                    overall: {
                                        DealerPaymentAmount: 0,
                                        DealerPaymentTDS: 0,
                                        grandTotal: 0,
                                        latestDealerPaymentDate: null
                                    },
                                    fileNoWise: {} // { fileNo: { DealerPaymentAmount, DealerPaymentTDS, grandTotal } }
                                };

                                data.forEach(record => {
                                    const fileNos = record.data?.map(d => d.fillNo) || [];

                                    (record.dealerPaymentDetails || []).forEach(dealerDetail => {
                                        (dealerDetail.DealerPaymentDetails || []).forEach(payment => {
                                            // if (fileNos.includes(payment.fileNo)) {
                                            const amount = Number(payment.DealerPaymentAmount || 0);
                                            const tds = Number(payment.DealerPaymentTDS || 0);

                                            // update overall totals
                                            result.overall.DealerPaymentAmount += amount;
                                            result.overall.DealerPaymentTDS += tds;
                                            result.overall.grandTotal += amount + tds;

                                            // update latestDealerPaymentDate (if valid date)
                                            if (payment.DealerPaymentDate) {
                                                const payDate = new Date(payment.DealerPaymentDate);
                                                if (
                                                    !result.overall.latestDealerPaymentDate ||
                                                    payDate > new Date(result.overall.latestDealerPaymentDate)
                                                ) {
                                                    result.overall.latestDealerPaymentDate = payment.DealerPaymentDate;
                                                }
                                            }

                                            // update fileNo-wise totals
                                            if (!result.fileNoWise[payment.fileNo]) {
                                                result.fileNoWise[payment.fileNo] = {
                                                    DealerPaymentAmount: 0,
                                                    DealerPaymentTDS: 0,
                                                    grandTotal: 0
                                                };
                                            }

                                            result.fileNoWise[payment.fileNo].DealerPaymentAmount += amount;
                                            result.fileNoWise[payment.fileNo].DealerPaymentTDS += tds;
                                            result.fileNoWise[payment.fileNo].grandTotal += amount + tds;
                                            // }
                                        });
                                    });
                                });
                                // your calculations here (totalAmt, result, invoiceNo, dealerName, etc.)
                                let totalPayment = data?.reduce((acc, v) => acc + parseFloat(v?.dealerCommission), 0);
                                let givenPayment = result?.overall?.grandTotal;
                                let dealerName = data[0]?.dealerUserData[0]?.name;
                                let date = new Date(data[0]?.submitDate)?.toLocaleDateString();
                                let invoiceNo = `Dealer/${dealerName}/${date}/${key}`;

                                let dealerPayBillObj = Dealerpayment?.find((v) => v.DealerPaymentInvoiceNo === invoiceNo);

                                // let givenP = dealerPayBillObj?.DealerPaymentDetails?.reduce((acc, v) => acc + v.DealerPaymentAmount + v.DealerPaymentTDS, 0)
                                let givenP = dealerPayBillObj?.DealerPaymentDetails?.reduce((acc, v) =>
                                    acc + (v.DealerPaymentAmount ?? 0) + (v.DealerPaymentTDS ?? 0), 0
                                );

                                let totalP = 0;

                                totalP = data.reduce((acc, v) => acc + parseInt(v.dealerCommission), 0)


                                // if (dealerPayBillObj) {
                                //     totalP = dealerPayBillObj?.DealerPaymentDetails?.reduce((acc, v) =>
                                //         acc + (v.DealerPaymentTotal ?? 0), 0
                                //     );
                                // } else {
                                //     totalP = data.reduce((acc, v) => acc + parseInt(v.dealerCommission) , 0)
                                // }



                                if (key === 10) {
                                    console.log("dealerPayBillObj 10", dealerPayBillObj, givenP, data[0]?.dealerPaymentDetails[0]);
                                }



                                console.log("v, id, month", data);

                                let dealerFilesData = [];

                                // console.log("dealerFilesData", key, data, data[0]?.dealerPaymentDetails[0] , data[0]?.dealerPaymentDetails[0]?.length === 0);

                                if (key == 4) {
                                    // console.log("dealerFilesData", key, data, data[0]?.dealerPaymentDetails[0] , data[0]?.dealerPaymentDetails[0]?.length === 0);
                                }


                                if (!dealerPayBillObj) {
                                    data.map((v) => {
                                        dealerFilesData.push({
                                            DealerPaymentAmount: 0,
                                            DealerPaymentDate: '',
                                            DealerPaymentTDS: 0,
                                            DealerPaymentTotal: v?.data[0]?.TotalCommission,
                                            commissionPerKW: v?.data[0]?.CommissionPerKW,
                                            fileNo: v?.data[0]?.fillNo,
                                            consumerName: v?.data[0]?.ConsumerName,
                                            systemSize: v?.data[0]?.SystemSizeKw,
                                            totalCommission: v?.data[0]?.TotalCommission,
                                            _id: '',
                                        })
                                    })
                                };

                                console.log("dealerPayBillObj", dealerPayBillObj);

                                const latestObj = dealerPayBillObj?.DealerPaymentDetails
                                    .filter(v => v.DealerPaymentDate) // remove null/undefined/missing
                                    .sort((a, b) => new Date(b.DealerPaymentDate) - new Date(a.DealerPaymentDate))[0];

                                console.log("latestDate", latestObj)

                                return (
                                    <TableRow key={index}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{invoiceNo}</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{date}</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{dealerName}</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{totalP}</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{givenP || 0}</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                            {latestObj?.DealerPaymentDate}
                                        </TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                            {givenP >= totalP ? 'Complete' : 'Pending'}
                                        </TableCell>
                                        {/* <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                            <IconButton aria-label="view" onClick={() => handleview(data)}>
                                                <RemoveRedEyeIcon />
                                            </IconButton>
                                        </TableCell> */}
                                        <TableCell>
                                            <IconButton aria-label="edit"
                                                onClick={() => handleEdit(
                                                    { dealerName, amount: totalPayment, invoiceNo, billNo: data[0]?.billNo },
                                                    data[0]?.billNo,
                                                    // data[0]?.dealerPaymentDetails[0] === undefined || data[0]?.dealerPaymentDetails?.length === 0 ? dealerFilesData : data[0]?.dealerPaymentDetails[0]?.DealerPaymentDetails,
                                                    dealerPayBillObj ? dealerPayBillObj?.DealerPaymentDetails : dealerFilesData,
                                                    dealerPayBillObj?._id,
                                                    data[0]?.dealerUserData[0]?._id
                                                )}>
                                                <EditIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>

                        <Dialog
                            fullScreen={fullScreen}
                            open={openView}
                            onClose={handleCloseView}
                            aria-labelledby="responsive-dialog-title"
                            maxWidth={"sm"}
                            fullWidth
                        >
                            <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: theme.palette.background.purple, textAlign: 'center', fontWeight: 700, fontSize: '16px' }}>
                                {"Customer Data"}
                            </DialogTitle>
                            <DialogContent style={{ backgroundColor: theme.palette.background.purple }}>
                                <DialogContentText>
                                    <Table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center' }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px', fontWeight: 700 }}>File No</TableCell>
                                                <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px', fontWeight: 700 }}>Consumer Name</TableCell>
                                                <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px', fontWeight: 700 }}>System Size</TableCell>
                                                <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px', fontWeight: 700 }}>CommissionKw</TableCell>
                                                <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px', fontWeight: 700 }}>Total Commission</TableCell>
                                                <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px', fontWeight: 700 }}>Pending Amount</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {viewData?.map((Kit, index) => (
                                                <TableRow key={index}>
                                                    <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px' }}>
                                                        {Kit?.data[0]?.fillNo || 'N/A'}
                                                    </TableCell>
                                                    <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px' }}>
                                                        {Kit?.ConsumerName || 'N/A'}
                                                    </TableCell>
                                                    <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px' }}>
                                                        {Kit?.SystemSize || 'N/A'}
                                                    </TableCell>
                                                    <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px' }}>
                                                        {Kit?.data[0]?.CommissionPerKW || 'N/A'}
                                                    </TableCell>
                                                    <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px' }}>
                                                        {Kit?.data[0]?.TotalCommission || 'N/A'}
                                                    </TableCell>
                                                    <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px' }}>
                                                        {Kit?.data[0]?.TotalCommission - Kit.dealerPaymentDetails[0].DealerPaymentDetails[0].DealerPaymentAmount}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions style={{ backgroundColor: theme.palette.background.purple }}>
                                <Button autoFocus onClick={handleCloseView} style={{ color: theme.palette.text.primary }}>
                                    Close
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </Table>
                </TableContainer>
            ) : (
                <Typography variant="h6" color="textSecondary" align="center" sx={{ mt: 4 }}>
                    No Data Available
                </Typography>
            )}


            {/* {sortedFab.length > 0 ? (
                <>
                    {sortedFab?.map(({ key, data }, index) => {
                        console.log("key, data", key, data);


                        let totalAmt = data?.reduce((acc, v) => acc + parseFloat(v?.dealerCommission), 0);

                        console.log(totalAmt);

                        const result = {
                            overall: {
                                DealerPaymentAmount: 0,
                                DealerPaymentTDS: 0,
                                grandTotal: 0,
                                latestDealerPaymentDate: null
                            },
                            fileNoWise: {} // { fileNo: { DealerPaymentAmount, DealerPaymentTDS, grandTotal } }
                        };

                        data.forEach(record => {
                            const fileNos = record.data?.map(d => d.fillNo) || [];

                            (record.dealerPaymentDetails || []).forEach(dealerDetail => {
                                (dealerDetail.DealerPaymentDetails || []).forEach(payment => {
                                    if (fileNos.includes(payment.fileNo)) {
                                        const amount = Number(payment.DealerPaymentAmount || 0);
                                        const tds = Number(payment.DealerPaymentTDS || 0);

                                        // update overall totals
                                        result.overall.DealerPaymentAmount += amount;
                                        result.overall.DealerPaymentTDS += tds;
                                        result.overall.grandTotal += amount + tds;

                                        // update latestDealerPaymentDate (if valid date)
                                        if (payment.DealerPaymentDate) {
                                            const payDate = new Date(payment.DealerPaymentDate);
                                            if (
                                                !result.overall.latestDealerPaymentDate ||
                                                payDate > new Date(result.overall.latestDealerPaymentDate)
                                            ) {
                                                result.overall.latestDealerPaymentDate = payment.DealerPaymentDate;
                                            }
                                        }

                                        // update fileNo-wise totals
                                        if (!result.fileNoWise[payment.fileNo]) {
                                            result.fileNoWise[payment.fileNo] = {
                                                DealerPaymentAmount: 0,
                                                DealerPaymentTDS: 0,
                                                grandTotal: 0
                                            };
                                        }

                                        result.fileNoWise[payment.fileNo].DealerPaymentAmount += amount;
                                        result.fileNoWise[payment.fileNo].DealerPaymentTDS += tds;
                                        result.fileNoWise[payment.fileNo].grandTotal += amount + tds;
                                    }
                                });
                            });
                        });

                        console.log("result",result);

                        const latestDate = data
                            ?.map(e => new Date(e?.paymentDate))
                            .filter(date => !isNaN(date)) // remove invalid dates
                            .sort((a, b) => b - a)[0];

                        console.log(latestDate);


                        // const formattedLatestDate = result?.overall?.latestDealerPaymentDate?.toLocaleDateString();

                        console.log("data[0]", data[0]);
                        let totalPayment = data?.reduce((acc, v) => acc + parseFloat(v?.dealerCommission), 0);;
                        let dealerName;
                        let InstallerPay;
                        let invoiceNo;
                        let InstallerpayTotal;
                        let date;
                        let givenPayment = result?.overall?.grandTotal;

                        invoiceNo = `Dealer/${data[0]?.dealerUserData[0]?.name}/${data[0]?.submitDate ? new Date(data[0]?.submitDate)?.toLocaleDateString() : new Date()?.toLocaleDateString()}/${key}`
                        date = new Date(data[0]?.submitDate)?.toLocaleDateString()
                        dealerName = data[0]?.dealerUserData[0]?.name
                        return (
                            <TableContainer>
                                <Table>
                                    <TableHead sx={{ backgroundColor: theme.palette.mode === 'dark' ? '#3e4396' : '#a4a9fc' }}>
                                        <TableRow>
                                            <TableCell style={{ width: '100px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>SR No.</TableCell>
                                            <TableCell style={{ width: '330px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Invoice No</TableCell>
                                            <TableCell style={{ width: '250px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Date of Period</TableCell>
                                            <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Dealer Name</TableCell>
                                            <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Total Amount</TableCell>
                                            <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Given Payment</TableCell>
                                            <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Payment Date</TableCell>
                                            <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Status</TableCell>
                                            <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Payment History</TableCell>
                                            <TableCell style={{ width: '200px' }} sx={{ fontSize: '14px', fontWeight: '600' }}>Action</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>

                                        <TableRow key={index}>
                                            <TableCell>
                                                {index + 1}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                {invoiceNo}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                {date}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                {dealerName}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                {totalPayment}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                {givenPayment}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                {new Date(result?.overall?.latestDealerPaymentDate).toLocaleDateString()}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                {givenPayment >= totalPayment ? 'Complete' : 'Pending'}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                                <IconButton aria-label="view" onClick={() => handleview()}>
                                                    <RemoveRedEyeIcon />
                                                </IconButton>
                                            </TableCell>
                                            <TableCell>
                                                <IconButton aria-label="edit" onClick={() => handleEdit()}>
                                                    <EditIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>





                                    </TableBody>

                                    <Dialog
                                        fullScreen={fullScreen}
                                        open={openView}
                                        onClose={handleCloseView}
                                        aria-labelledby="responsive-dialog-title"
                                        maxWidth={"sm"}
                                        fullWidth
                                    >
                                        <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: theme.palette.background.purple, textAlign: 'center', fontWeight: 700, fontSize: '16px' }}>
                                            {"Customer Data"}
                                        </DialogTitle>
                                        <DialogContent style={{ backgroundColor: theme.palette.background.purple }}>
                                            <DialogContentText>
                                                <Table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center' }}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px', fontWeight: 700 }}>File No</TableCell>
                                                            <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px', fontWeight: 700 }}>Consumer Name</TableCell>
                                                            <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px', fontWeight: 700 }}>System Size</TableCell>
                                                            <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px', fontWeight: 700 }}>CommissionKw</TableCell>
                                                            <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px', fontWeight: 700 }}>Total Commission</TableCell>
                                                            <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px', fontWeight: 700 }}>Pending Amount</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {viewData?.paymentData?.details?.map((Kit, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px' }}>
                                                                    {Kit?.fileNo || 'N/A'}
                                                                </TableCell>
                                                                <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px' }}>
                                                                    {Kit?.Consumername || 'N/A'}
                                                                </TableCell>
                                                                <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px' }}>
                                                                    {Kit?.SystemSize || 'N/A'}
                                                                </TableCell>
                                                                <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px' }}>
                                                                    {Kit?.CommissionKw || 'N/A'}
                                                                </TableCell>
                                                                <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px' }}>
                                                                    {Kit?.commission || 'N/A'}
                                                                </TableCell>
                                                                <TableCell style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px', fontSize: '14px' }}>
                                                                    {Kit.TotalAmount - Kit.AccountTotal}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </DialogContentText>
                                        </DialogContent>
                                        <DialogActions style={{ backgroundColor: theme.palette.background.purple }}>
                                            <Button autoFocus onClick={handleCloseView} style={{ color: theme.palette.text.primary }}>
                                                Close
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                </Table>
                            </TableContainer>

                        )
                    })}
                </>
            )
                : (
                    <Typography variant="h6" color="textSecondary" align="center" sx={{ mt: 4 }}>
                        No Data Availble
                    </Typography>
                )} */}
        </Box >
    )
}

export default Dealerpayment